import React, { ReactElement } from "react";
import { Box, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  FormatBold,
  FormatIndentDecrease,
  FormatIndentIncrease,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatUnderlined,
  Redo,
  TableChartOutlined,
  Undo,
} from "@mui/icons-material";
import { useCurrentEditor } from "@tiptap/react";
import TextAlign from "./Actions/TextAlign";
import LineHeight from "./Actions/LineHeight";
import InsertLink from "./Actions/InsertLink";
import { LegalbirdTipTapEditorTableBubbleMenu } from "../Table/LegalbirdTipTapEditorTableBubbleMenu";
import tipTapToolbarStyles from "./tipTapToolbarStyles.ts";

type TipTapToolbarProps = {
  additionalActions?: ReactElement[];
  stickyTop?: `${number}rem`;
};
export default function TipTapToolbar({ additionalActions, stickyTop = "0rem" }: TipTapToolbarProps) {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <Box sx={tipTapToolbarStyles.container(stickyTop)}>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: "center",
          mb: "1rem",
        }}
      >
        <Grid>
          <ToggleButtonGroup size={"small"}>
            <ToggleButton
              value={"b"}
              selected={editor.isActive("bold")}
              onChange={() => editor.chain().focus().toggleBold().run()}
            >
              <FormatBold />
            </ToggleButton>
            <ToggleButton
              value={"i"}
              selected={editor.isActive("italic")}
              onChange={() => editor.chain().focus().toggleItalic().run()}
            >
              <FormatItalic />
            </ToggleButton>
            <ToggleButton
              value={"u"}
              selected={editor.isActive("underline")}
              onChange={() => editor.chain().focus().toggleUnderline().run()}
            >
              <FormatUnderlined />
            </ToggleButton>
            <ToggleButton
              value={"ul"}
              selected={editor.isActive("bulletList")}
              onChange={() => editor.chain().focus().toggleBulletList().run()}
            >
              <FormatListBulleted />
            </ToggleButton>
            <ToggleButton
              value={"ol"}
              selected={editor.isActive("orderedList")}
              onChange={() => editor.chain().focus().toggleOrderedList().run()}
            >
              <FormatListNumbered />
            </ToggleButton>
            <InsertLink />
            <ToggleButton value={""} onChange={() => editor?.commands.indent()}>
              <FormatIndentIncrease />
            </ToggleButton>
            <ToggleButton value={""} onChange={() => editor?.commands.outdent()}>
              <FormatIndentDecrease />
            </ToggleButton>
            <LineHeight />
            <TextAlign />
            <ToggleButton value={""} onChange={() => editor.commands.insertTableWrapper()}>
              <TableChartOutlined />
            </ToggleButton>
            <LegalbirdTipTapEditorTableBubbleMenu />
            <ToggleButton value={""} onChange={() => editor.commands.undo()}>
              <Undo />
            </ToggleButton>
            <ToggleButton value={""} onChange={() => editor.commands.redo()}>
              <Redo />
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        {additionalActions?.map((additionalAction, index) => (
          <Grid key={index}>{additionalAction}</Grid>
        ))}
      </Grid>
    </Box>
  );
}
